import React, {useEffect} from 'react'
import {ImageGroup} from '../../types/cms'
import {SlotComponent} from '../../types/ui'
import {Flex, Text} from '../../vanilla'
import {Carousel} from '../carousel'
import PromotionCard from './PromotionCard'
import {usePromotionStore} from '../../store/hooks/useStore'

interface PromotionListItem {
  id: string
  image: ImageGroup
}

interface PromotionListProps {
  title: string
  displayType: 'Carousel' | 'List'
  promotions: PromotionListItem[]
}

const PromotionList: SlotComponent<PromotionListProps> = ({content, slotIndex, slotGroupName}) => {
  const promotionStore = usePromotionStore()

  useEffect(() => {
    if (!Array.isArray(content.promotions) || content.promotions.length === 0) {
      return
    }

    promotionStore.fetchPromotionsByIds(
      content.promotions.map((i) => i.id),
      false
    )
  }, [content.promotions])

  if (content.displayType === 'List') {
    return (
      <Flex direction="column">
        <Text as="h3" variant="heading3" marginBottom="24px" lineHeight="tall">
          {content.title}
        </Text>
        {content?.promotions?.map((item, idx) => {
          return (
            <PromotionCard
              promoID={item.id}
              image={item.image}
              key={`promotion-card-carousel-item-${item.id}`}
              slotName={typeof slotGroupName === 'string' ? slotGroupName : undefined}
              slotIndex={!isNaN(Number(slotIndex)) ? Number(slotIndex) : 1}
              listIndex={idx + 1}
            />
          )
        })}
      </Flex>
    )
  }

  return (
    <Flex direction="column" width="full">
      <Text as="h3" variant="heading3" marginBottom="24px" lineHeight="tall">
        {content.title}
      </Text>
      <Carousel
        className="promotion-list-carousel"
        loop
        autoPlay
        mobilePeekMode
        itemsPerSide={{desktop: 3, mobile: 1, tablet: 1}}
        controlsPosition="outerBottom"
        itemClassName="promotion-list-carousel-item"
        minimumTouchDrag={20}
        controlConfig={{
          activeDotColor: 'accent0',
          arrowsBgColor: 'transparent',
          arrowsColor: 'accent0',
          arrowsOutline: true,
          dotsOutline: true,
          showArrows: {mobile: false, desktop: true, tablet: true}
        }}
      >
        {content?.promotions?.map((item, idx) => {
          return (
            <PromotionCard
              promoID={item.id}
              image={item.image}
              key={`promotion-card-carousel-item-${item.id}`}
              slotName={typeof slotGroupName === 'string' ? slotGroupName : undefined}
              slotIndex={!isNaN(Number(slotIndex)) ? Number(slotIndex) : 1}
              listIndex={idx + 1}
            />
          )
        })}
      </Carousel>
    </Flex>
  )
}

export default PromotionList
